import React from 'react';
import { Grid, Typography } from '@mui/material';


function SuccessCreateAccount({ personData, selectedPlan, planData }) {

    React.useEffect(() => {
        window.gtag('event', 'conversion', { send_to: 'AW-767300505/6csuCKyB-rwYEJmn8o0C' });
    }, []);

    return (
        <Grid style={styles.container}>
            <Typography variant="h4" style={styles.title}>
                Conta criada com sucesso,<br />
                {personData?.firstName}.
            </Typography>
            <Typography style={styles.firstSubtitle}>
                Parabéns! Sua conta premium foi criada com sucesso.
            </Typography>
            <Typography style={styles.subtitle}>
                A partir de agora, você terá acesso a todas as funcionalidades e benefícios do nosso serviço.
            </Typography>
            <Typography style={styles.subtitle}>
                Em caso de dúvidas ou problemas, entre em contato com nosso suporte técnico.
            </Typography>
            <Typography style={styles.subtitle}>
                Comece já e aproveite ao máximo o nosso serviço.
            </Typography>
        </Grid>
    )
}

export default SuccessCreateAccount;

const styles = ({
    container: {
        justifyContent: 'flex-start',
        display: 'flex',
        padding: '5em',
        flexDirection: 'column'
    },
    title: {
        fontFamily: 'Heebo',
        textAlign: 'left'
    },
    firstSubtitle: {
        textAlign: 'left',
        fontFamily: 'Sen',
        fontSize: 18,
        lineHeight: '18px',
        paddingBottom: '25px',
        marginTop: '3em',
    },
    subtitle: {
        textAlign: 'left',
        fontFamily: 'Sen',
        fontSize: 18,
        lineHeight: '18px',
        paddingBottom: '25px',
    }
})